/* eslint no-underscore-dangle: 0 */
import axios from 'axios';
import {
	getToken,
	getUser,
	logout,
	setUser,
} from '../features/authentication/utils/auth';

const instance = axios.create({
	baseURL: 'http://localhost:8080/api',
	headers: {
		'Content-Type': 'application/json',
		'Accept-Language': 'fr-FR,fr',
		Accept: 'application/json',
	},
	timeout: 40000,
});

instance.interceptors.request.use(
	(config) => {
		const token = getToken();
		let formattedToken;
		if (token) {
			formattedToken = `Bearer ${token}`;
		}
		return {
			...config,
			headers: {
				...config.headers,
				Authorization: token && formattedToken,
			},
		};
	},
	(error) => Promise.reject(error),
);

instance.interceptors.response.use(
	(res) => res,
	async (err) => {
		const originalConfig = err.config;

		if (
			originalConfig.url !==
				`${process.env.REACT_APP_API_ENDPOINT}auth/token/refresh` &&
			err.response
		) {
			// Access Token was expired

			if (err.response.status === 401 && !originalConfig._retry) {
				originalConfig._retry = true;

				try {
					const { refreshToken } = getUser();
					const rs = await instance.post(
						`${process.env.REACT_APP_API_ENDPOINT}auth/token/refresh`,
						{
							refresh_token: refreshToken,
						},
					);

					const { token, newRefreshToken } = rs.data;
					setUser({
						...getUser(),
						token,
						refreshToken: newRefreshToken,
					});

					return instance(originalConfig);
				} catch (_error) {
					return Promise.reject(_error);
				}
			}
		}

		if (
			originalConfig.url ===
			`${process.env.REACT_APP_API_ENDPOINT}auth/token/refresh`
		) {
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			await logout(() => {});
			window.location.href = '/login';
		}
		return Promise.reject(err);
	},
);
export default instance;
